// extracted by mini-css-extract-plugin
module.exports = {"productCallout":"Zp-z"};